import React, { useContext } from 'react'
import { Form } from 'react-bootstrap'

import { FieldContext } from 'contexts/fieldContext'
import { DataConnectionContext } from 'contexts/dataConnectionContext'

const Boolean = () => {

    let resourceFieldValue = useContext(FieldContext)
    let dataConnection = useContext(DataConnectionContext)

    let item = dataConnection.data
    let { setData } = dataConnection

    const handleChange = (e) => {
        setData({
            ...item,
            [e.target.name]: e.target.value
        })
    }

    return <Form.Control
        type='checkbox'
        onChange={handleChange}
        name={resourceFieldValue.resourceField.fieldName}
        placeholder={resourceFieldValue.resourceField.fieldName}
        checked={resourceFieldValue.value}
    />
}


export default Boolean